"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaulAbilityHandler = exports.MaulActorAbilityFactory = exports.MaulAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const EffectType_1 = require("../../core/effects/EffectType");
class MaulAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Maul;
        this.__typeName = "Maul";
    }
}
exports.MaulAbilityArgs = MaulAbilityArgs;
let MaulActorAbilityFactory = class MaulActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Maul", "OneEnemies", 2);
    }
};
MaulActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Maul")
], MaulActorAbilityFactory);
exports.MaulActorAbilityFactory = MaulActorAbilityFactory;
let MaulAbilityHandler = class MaulAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 70)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.BleedingEffectArgs("Power", 10),
                });
                if (container.hasAttribute(ability.invokerId, "Charm_Monk_1")
                    && !container.isDeceased(selectedEnemy)
                    && !container.hasEffectOfType(selectedEnemy, EffectType_1.EffectType.LikeABoss)
                    && container.testAttribute(ability.invokerId, "Luck", 20)) {
                    container.applyEffect(sequence, ability.invokerId, selectedEnemy, new core_1.DeathEffectArgs());
                }
            }
        });
    }
};
MaulAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Maul)
], MaulAbilityHandler);
exports.MaulAbilityHandler = MaulAbilityHandler;
